// src/store/slices/clientEntitySlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ClientEntityState {
  selectedEntity: string | null;
}

const initialState: ClientEntityState = {
  selectedEntity: null,
};

const clientEntitySlice = createSlice({
  name: 'clientEntity',
  initialState,
  reducers: {
    setEntity: (state, action: PayloadAction<string>) => {
      state.selectedEntity = action.payload;
    },
    clearEntity: (state) => {
      state.selectedEntity = null;
    },
  },
});

export const { setEntity, clearEntity } = clientEntitySlice.actions;

export default clientEntitySlice.reducer;
